import { MapAutocompleteDTO } from './MapAutocompleteDTO'
import { Attribute } from './Attribute'
import { CustomValidation } from './CustomValidation'
import { ControlLayout } from '../Enums/ControlLayout'

export class MapAutoCompleteOptions
{
   /**
 * Represent Name Of  MapAutoCompleteContoler
 */
Name:string
/**
*   Represent classes to textbox that allow us to select the  MapAutoComplete by jquery or javascript 
*/

ExtraClasses:string
/**  Represent value of the label*/
LabelValue:string
 /**  Represent Key of the label*/
 LabelKey:string
/**  Represent value of the labelDescription show under MapAutoComplete*/
LabelDescription:string
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
CustomValidation: CustomValidation[]=[]
/**  to set type of view  if MapAutoComplete is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
/** Represent value of the Placeholder of MapAutoComplete */
Placeholder:string
 /**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */ 
  ShowAsterisk: boolean
  /** Ability to set  MapAutoComplete required */
  IsRequired: boolean
  /** Ability to display or hide the label of MapAutoComplete */
  HideLabel:  boolean
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
/** Set List of Custom Attribute to TextArea  */
    AttributeList:Attribute[]
 /** Sets Value of MapAutoComplete  */
  Value:MapAutocompleteDTO
 
}